/** "11 Oct"; the year only when it is not this one. UTC, so a day does not move with the reader. */
export function formatShortDate(value: Date | string): string {
  const date = new Date(value)
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
    ...(date.getUTCFullYear() === new Date().getUTCFullYear() ? {} : { year: 'numeric' }),
  })
}
